import { atom, useAtom } from "jotai";

// Chat „Dokumenty“ hľadá vo všetkých priečinkoch používateľa (BE: chat_service.ALL_FOLDERS)
export const ALL_FOLDERS = 'all';

export const chatEnvironmentAtom = atom(undefined);

export function useChatEnvironmentAtom() {
    return useAtom(chatEnvironmentAtom);
}
